export * from './icon';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/icon/index.js
// module id = 392
// module chunks = 3